// Формирует человекочитаемое имя Saby-интеграции для выбора кабинета ЭДО.
export function edoSabyIntegrationLabel(integration) {
  if (!integration) return "Saby";

  return [
    integration.name || integration.provider_name || "Saby",
    integration.org_name,
    integration.org_inn ? `ИНН ${integration.org_inn}` : null,
    integration.login,
  ].filter(Boolean).join(" · ");
}
